import { Link } from "@/src/components/nav/index";
import { TabConfig } from "@/src/components/nav/types";
import { useCallback } from "react";
import { FirmRoleRestricted } from "../FirmRoleRestricted";

interface TopTabNavbarProps {
  tabs: TabConfig[];
}

const FirmNavbar = ({ tabs }: TopTabNavbarProps) => {
  const renderItem = useCallback(
    ({
      firmAccountTypes,
      label,
      icon,
      to,
      iconActiveColor,
      iconInactiveColor,
      ...config
    }: TabConfig) => {
      return (
        <Link
          margin="0 0 xs 0"
          to={to}
          iconActiveColor={iconActiveColor}
          iconInactiveColor={iconInactiveColor}
          {...config}
        >
          {({ isActive, iconActiveColor, iconInactiveColor }) => (
            <div className="flex items-center space-x-2">
              <div
                className={
                  isActive
                    ? iconActiveColor || "text-persian-300"
                    : iconInactiveColor || "text-persian-800"
                }
              >
                {icon}
              </div>
              <span className="text-sm font-semibold truncate">{label}</span>
            </div>
          )}
        </Link>
      );
    },
    [],
  );

  return (
    <nav className="transition-colors duration-300 ease-in-out bg-whitegray-200 gap-x-2 overflow-x-scroll no-scrollbar p-1.5">
      <ul className={"flex flex-row gap-x-2"}>
        {tabs.map((tabConfig) => (
          <li key={tabConfig.to}>
            {tabConfig.firmAccountTypes ? (
              <FirmRoleRestricted roles={tabConfig.firmAccountTypes}>
                {renderItem(tabConfig)}
              </FirmRoleRestricted>
            ) : (
              <>{renderItem(tabConfig)}</>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};
export default FirmNavbar;
